import { useEffect, useState } from "react";
import { Upload } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Field } from "@/components/ProfileFields";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { PageTitle, Panel } from "./AdminLayout";
import { fileToDataUrl } from "./EventForm";

export default function Donation() {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/admin/donation").then((r) => setD(r.data));
  }, []);
  const save = async (patch = {}) => {
    try {
      setD((await api.put("/admin/donation", { ...d, ...patch })).data);
      toast.success("Pengaturan Kontribusi Kolektif disimpan.");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const upload = async (f) => {
    if (!f) return;
    if (f.size > 1500000) return toast.error("Maksimal 1.5MB.");
    save({ qris_image: await fileToDataUrl(f) });
  };
  if (!d) return null;
  return (
    <div className="max-w-3xl">
      <PageTitle
        title="Kontribusi Kolektif QRIS"
        desc="Satu QRIS untuk semua event — cukup unggah sekali di sini. Tampilan saja, tanpa verifikasi pembayaran; tidak memengaruhi check-in atau antrean."
      />
      <Panel>
        <div className="grid gap-6 md:grid-cols-[220px_1fr]">
          <div className="space-y-3">
            {d.qris_image ? <img src={d.qris_image} alt="QRIS" className="w-full rounded-xl ring-1 ring-black/10" data-testid="admin-qris-preview" /> : <div className="flex aspect-square items-center justify-center rounded-xl border border-dashed text-sm text-muted-foreground">Belum ada QRIS</div>}
            <label className="block cursor-pointer"><span className="inline-flex w-full items-center justify-center rounded-full border px-4 py-2 text-sm font-semibold hover:bg-[#EDE9DC]"><Upload className="mr-1.5 h-4 w-4" /> Unggah QRIS</span>
              <input type="file" accept="image/*" className="hidden" onChange={(e) => upload(e.target.files[0])} data-testid="admin-qris-upload" /></label>
          </div>
          <div className="space-y-4">
            <Field label="Nama penerima"><Input value={d.account_name || ""} onChange={(e) => setD({ ...d, account_name: e.target.value })} data-testid="donation-account-input" /></Field>
            <Field label="Penjelasan Kontribusi Kolektif / pesan">
              <Textarea
                rows={5}
                value={d.explanation || ""}
                onChange={(e) => setD({ ...d, explanation: e.target.value })}
                data-testid="donation-explanation-input"
              />
            </Field>
            <Button onClick={() => save()} className="rounded-full" data-testid="donation-save-button">Simpan</Button>
          </div>
        </div>
      </Panel>
    </div>
  );
}
